<template>
  <div class="container">
    <el-card>
      <div slot="header">小程序账户管理</div>
      <div style="height: 100%">
        <div>
          <el-button type="primary" icon="el-icon-delete" size="small" @click="deleteMeter" style="background-color: #ed5565 !important">删除</el-button>
          <el-button type="primary" class="iconfont icon-excel" size="small" @click="exportToExcel" style="background-color: #23c6c8 !important">导出</el-button>
        </div>
        <el-form ref="form" :model="form" label-width="80px" size="small" class="searchForm">
          <el-form-item label="手机号">
            <el-input v-model="queryParams.phone" class="searchTag" clearable placeholder="手机号">
            </el-input>
          </el-form-item>
          <el-button type="primary" icon="el-icon-search" size="small" style="margin-left: 10px" @click="handleQuery">搜索</el-button>
        </el-form>
        <div class="tableStyle">
          <el-table :data="tableData" ref="nbCardInfoTable" style="width:fit-content " height="90%" v-loading="loading" id="nbRecordTable" highlight-current-row @current-change="handleCurrentChange">
            <el-table-column type="index" width="50" label="序号" align="center" :index="indexMethod">
            </el-table-column>
            <el-table-column prop="name" label="名称" width="250" align="center">
            </el-table-column>
            <el-table-column prop="phone" label="手机号码" width="250" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center" width="150">
              <template slot-scope="scope">
                <el-button size="mini" type="text" icon="el-icon-user" @click="resetPassword(scope.row)">重置密码</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="block">
            <el-pagination v-show="total > 0" @size-change="handleQuery" @current-change="handleQuery" :current-page.sync="queryParams.current" :page-sizes="[100, 200, 400, 600, 800, 1000]" :page-size.sync="queryParams.size" layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import {
  translateObjectEmptyAttributeToNull,
} from '../../untils/func';
import exportTable from '../../untils/exportTable';
import {
  selectList,
  remove,
  resetAppletPassword
} from '../../api/property/appletAccount';

export default {
  data () {
    return {
      form: {},
      // 字典表格数据
      tableData: [],
      // 查询参数
      queryParams: {
        current: 1,
        size: 100,
      },
      // 遮罩层
      loading: true,
      total: 0,
      currentRow: null,

    };
  },
  created () {
    this.init();
  },
  mounted () { },
  watch: {},
  methods: {
    async init () {
      await this.handleQuery();
    },
    async handleQuery () {
      this.loading = true;
      let param = this.queryParams;
      param = translateObjectEmptyAttributeToNull(param);
      const response = await selectList(param).then();
      this.tableData = response.data;
      // console.log(this.tableData);
      this.total = response.total;
      this.loading = false;
      this.cancelChoose();
    },
    cancelChoose () {
      this.$refs.nbCardInfoTable.setCurrentRow();
      this.currentRow = null;
    },
    deleteMeter () {
      if (this.currentRow == null) {
        this.$message.error('请先选择某条数据！');
      } else {
        this.$confirm('确定要删除吗?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          await remove(this.currentRow).then();
          await this.handleQuery();
          this.msgSuccess('删除成功');
        });
      }
    },
    // 单选表格某一行
    handleCurrentChange (val) {
      this.currentRow = val.id;
    },
    // 导出表格
    async exportToExcel () {
      if (this.tableData.length === 0) {
        this.$message.warning('无数据');
        return;
      } else {
        let size = this.queryParams.size;
        this.queryParams.size = this.total;
        this.queryParams.current = 1;
        await this.handleQuery();
        exportTable.exportExcel('nbRecordTable', '小程序账户信息');
        this.queryParams.size = size;
        await this.handleQuery();
      }
    },
    indexMethod (index) {
      let num =
        this.queryParams.size * (this.queryParams.current - 1) + index + 1;
      return num;
    },
    resetPassword (row) {
      this.$confirm('确定要重置密码吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        await resetAppletPassword({
          id: row.id
        }).then();
        this.msgSuccess('重置密码成功');
        await this.handleQuery();
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0 10px;
  height: 100%;
}

/deep/ .el-card__header {
  background-color: var(--secondColor) !important;
  color: var(--whiteColor);
}

/deep/ .el-select {
  width: 100%;
}

/deep/ .el-input {
  width: 100%;
}

.searchTag {
  width: 200px;
}

.searchForm {
  margin-top: 15px;

  .el-form-item {
    display: inline-block;
  }
}

.tableStyle {
  height: calc(100% - 80px);
  // background-color: pink;
}

@media screen and (max-width: 1414px) {
  .tableStyle {
    height: calc(100% - 130px);
  }
}
.block {
  margin-top: 10px;
}
</style>
